// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 542) return "katal.4b627f54.css";
	if (chunkId === 96) return "vendors.4310d004.css";
	if (chunkId === 792) return "main.df046bb4.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"64":"dbd87ba7","167":"e786d7db","407":"19acbae1","478":"3ba89535","703":"d6644c5a","781":"cedd805b","966":"54a48005"}[chunkId] + ".chunk.css";
};